/*
 * @Author: zhouhm 1148305943@qq.com
 * @Date: 2025-08-25 17:15:05
 * @LastEditors: zhouhm 1148305943@qq.com
 * @LastEditTime: 2025-09-22 15:56:26
 * @FilePath: \road_monitor_app\src\view\yeMast\yeMast_index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import 'xgplayer'
import Player, { Events } from "xgplayer";
import HlsPlugin from "xgplayer-hls";
import "xgplayer/dist/index.min.css";
// import {

// } from "@/api/api";
export default {
    name: "yeMast",
    data() {
        return {
            // timer: null,
            player: null,
            videoData: {
                videoUrl: ''
            },
            hasUrl: false,
            workareaId: "",
            site: "",
            authkey: "",

            // 多个视频
            videoUrl: "",
            videoList: [],
            checkVideo: false, // 切换视频
        };
    },
    created() {

    },
    mounted() {
        let queryObj = this.$route.query
        this.workareaId = queryObj.workareaId
        this.site = queryObj.site
        this.authkey = queryObj.authkey
        let timestamp = Date.now().toString()
        let timestampQuery = this.authkey.slice(0, 13)
        if(Number(timestamp) - Number(timestampQuery) > 10000){
            this.$route.push({
                path: '/noData'
            })
            return
        }
        this.getImg()
    },
    watch: {},
    beforeDestroy() {
        if (this.player) {
            this.player.destroy();
            this.player = null;
        }
    },
    methods: {
        //获取视频信息
        async getImg() {
            this.hasUrl = false;
            let params = {
                workareaId: this.workareaId,
                site: this.site
            };
            await axios({
                method: 'get',
                url: 'https://cqc-mobile.jsti-smart.cn/api/ys7/getAllAtWorkAreaId',
                headers: {
                    'authkey': this.generateTimestampId()
                },
                params: params
            }).then(res => {
                if (res.data.length == 0) {

                } else {
                    this.videoList = [...res.data]
                    // this.getFlow();
                    this.hasUrl = true;
                    // this.videoData.videoUrl = 'https://open.ys7.com/v3/openlive/F86729830_15_2.m3u8?expire=1686362736&id=457123504842211328&t=d98d63ccb486fd9e95f09bd2eb070113d7661c5ed454e74b4a2eebd5859de546&ev=100';
                    this.videoUrl = res.data[0].url
                    this.videoData.videoUrl = res.data[0].url;
                    setTimeout(()=>{
                        this.player = new Player({
                            id: "mse",
                            isLive: true,
                            url: res.data[0].url,
                            height: "100%",
                            width: "100%",
                            cssFullscreen: false,
                            plugins: [HlsPlugin],
                        });
                    },500)
                    // console.log(res.data[0].url)
                    // setTimeout(() => {
                    //     this.$nextTick(() => {
                    //         this.$refs.player.play();
                    //     })
                    // }, 250)

                }
            });
        },

        // 生成：当前时间戳 + 16位数字字母随机串
        generateTimestampId() {
            const timestamp = Date.now().toString();
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let rand = '';

            if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
                // 浏览器安全随机
                const arr = new Uint32Array(16);
                crypto.getRandomValues(arr);
                for (const n of arr) rand += chars[n % chars.length];
            } else {
                try {
                    // Node.js 安全随机
                    const { randomBytes } = require('crypto');
                    const buf = randomBytes(16);
                    for (const n of buf) rand += chars[n % chars.length];
                } catch (err) {
                    // 兜底
                    for (let i = 0; i < 16; i++) rand += chars[Math.floor(Math.random() * chars.length)];
                }
            }

            return timestamp + rand;
        },

        changeVideo(val) {
            this.checkVideo = true;
            this.videoData.videoUrl = this.videoUrl;
            setTimeout(() => {
                this.checkVideo = false;
                setTimeout(() => {
                    this.$nextTick(() => {
                        this.$refs.player.play();
                    })
                }, 250)
            }, 250)
        },
    },
    beforeDestroy() {}
};


// WEBPACK FOOTER //
// ./src/view/yeMast/yeMast_index.js